import { PIE_CHART_COLORS } from '../../Chart'

import { StatisticChartTab } from './StatisticChartTab'
import { StatisticSummaryTab } from './StatisticSummaryTab'

export const STATISTIC_SUMMARY_TAB = 'summaryTab'

export const STATISTIC_ROLE_TAB = 'roleTab'

export const STATISTIC_STATUS_TAB = 'statusTab'

export const STATISTIC_CONTACT_TAB = 'contactTab'

export const QA_NAME_STATISTIC_MODAL = 'Statistic'

export const STATUS_COLORS_STACK = [
  'var(--color-chart-1)',
  'var(--color-chart-2)',
  'var(--color-chart-5)',
  'var(--color-chart-4)',
  'var(--color-chart-3)',
]

export const TAB_COMPONENT = {
  [STATISTIC_CONTACT_TAB]: StatisticChartTab,
  [STATISTIC_ROLE_TAB]: StatisticChartTab,
  [STATISTIC_STATUS_TAB]: StatisticChartTab,
  [STATISTIC_SUMMARY_TAB]: StatisticSummaryTab,
}

export const COLOR_STACK = {
  [STATISTIC_CONTACT_TAB]: STATUS_COLORS_STACK,
  [STATISTIC_ROLE_TAB]: PIE_CHART_COLORS,
  [STATISTIC_STATUS_TAB]: STATUS_COLORS_STACK,
}
